import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Payment",
    subheader:
      "Customize the checkout payment terms for your use case. Accept payment now or capture payment details for charging later."
  }),
  rows: [
    {
      title: {
        value: "Authorization",
        tooltip:
          "Your customer authorizes a payment, their bank guarantees the amount and holds it on the customer’s card for up to seven days."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Adjustable quantities",
        tooltip: "Allow your customers to change their purchase quantity."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Free trial",
        tooltip: "Set free trial period days"
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Manual promotion codes",
        tooltip: "Control whether customers can manually add a coupon"
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Pre applied coupons",
        tooltip: "Pre-apply a coupon to a payment link."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "One off charge amounts",
        tooltip: "Set the price for a pay amount to be charged."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Payment methods",
        tooltip: "Set which payment methods customer can use."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Multiple products",
        tooltip: "Add more than one product to the payment link."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Add payment details",
        tooltip: "Capture payment details only, so you can charge later."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Shipping rates",
        tooltip: "Add a shipping rate to any payment link."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
